<template>
  <div class="page-default">
    <div class="map-section">
      <div class="dashboard-map">
        <div class="map-body">
          <div
            class="
              d-flex
              justify-content-start
              align-items-center
              map-filter-defects
            "
          >
            <div class="dropdown">
              <button
                class="btn btn-sm dropdown-toggle position-relative"
                :class="currentDistrict ? 'btn-primary' : 'btn-light'"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span>
                  <font-awesome-icon :icon="['fas', 'filter']" />
                  <font-awesome-icon
                    :icon="['fas', 'check-circle']"
                    class="text-success"
                    style="
                      font-size: 0.85em;
                      position: absolute;
                      top: 0.25em;
                      right: 0.25em;
                    "
                    v-if="currentDistrict"
                  />
                </span>
              </button>
              <div
                class="dropdown-menu"
                aria-labelledby="dropdownMenuButton"
                style="max-height: 200px; overflow-y: auto"
              >
                <button
                  class="
                    dropdown-item
                    font-weight-medium
                    d-flex
                    justify-content-between
                    align-items-center
                  "
                  @click="currentDistrict = null"
                >
                  All districts
                  <font-awesome-icon
                    :icon="['fas', 'check']"
                    class="text-primary ml-3 small"
                    v-if="currentDistrict == null"
                  />
                </button>
                <button
                  v-for="district in districts"
                  :key="district._id"
                  class="
                    dropdown-item
                    d-flex
                    justify-content-between
                    align-items-center
                  "
                  @click="currentDistrict = district"
                >
                  {{ district.name }}
                  <font-awesome-icon
                    :icon="['fas', 'check']"
                    class="text-primary ml-3 small"
                    v-if="
                      currentDistrict && currentDistrict._id == district._id
                    "
                  />
                </button>
              </div>
            </div>
            <div class="dropdown ml-2">
              <button
                id="dropdownMenuButton"
                type="button"
                class="btn btn-sm dropdown-toggle"
                :class="!dateFilter ? 'btn-light' : 'btn-primary'"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <font-awesome-icon :icon="['far', 'calendar-alt']" />
                <font-awesome-icon
                  :icon="['fas', 'check-circle']"
                  class="text-success"
                  style="
                    font-size: 0.85em;
                    position: absolute;
                    top: 0.25em;
                    right: 0.25em;
                  "
                  v-if="dateFilter"
                />
              </button>
              <div id="dropdown-menu" class="dropdown-menu px-2" @click.stop>
                <div
                  class="
                    dropdown-item-text
                    d-flex
                    justify-content-between
                    align-items-center
                    px-0
                    pb-2
                  "
                >
                  <p class="badge badge-primary mb-0 font-weight-normal p-2">
                    Filter by date
                  </p>
                  <button
                    class="btn btn-sm btn-link p-0"
                    @click="dateFilter = null"
                  >
                    Clear
                  </button>
                </div>
                <v-date-picker
                  class="inline-calendar"
                  v-model="dateFilter"
                  :model-config="{
                    type: 'string',
                    mask: 'YYYY-MM-DD',
                  }"
                  mode="date"
                  trim-weeks
                  is-range
                />
              </div>
            </div>
          </div>
          <div class="map-filter-defects" :style="{ top: '3.5rem', zIndex: 9 }">
            <div class="dropdown">
              <button
                class="btn btn-sm btn-light dropdown-toggle position-relative"
                type="button"
                id="layerMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span class="mr-1">Layers</span>
              </button>
              <div
                id="dropdown-layer-menu"
                aria-labelledby="layerMenuButton"
                class="dropdown-menu"
              >
                <div
                  class="dropdown-item-text"
                  :key="`layer-${layer.id}`"
                  v-for="layer in layers"
                  @click.stop
                >
                  <div class="custom-control custom-checkbox py-2">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      :id="layer.id"
                      v-model="layer.show"
                      @change="toggleLayerVisibility(layer)"
                    />
                    <label
                      class="custom-control-label text-nowrap"
                      :for="layer.id"
                    >
                      {{ layer.name }}
                    </label>
                  </div>
                </div>
                <div
                  class="dropdown-item-text text-muted"
                  @click.stop
                  v-if="layers.length < 1"
                >
                  No layer found
                </div>
              </div>
            </div>
          </div>
          <div id="map"></div>
          <div class="map-legend bg-dark text-light">
            <p class="font-weight-medium mb-2">Legend</p>
            <div
              class="
                d-flex
                flex-column flex-wrap
                justify-content-start
                align-items-start
              "
            >
              <div class="legend-item">
                <div class="defect-marker mr-2"></div>
                Defect
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <media-preview
      v-if="currentImage"
      :url="currentImage"
      @close="currentImage = null"
    />
    <spinner v-if="isProcessing" />
  </div>
</template>

<script>
import API from "@/api";
import "mapbox-gl";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import $ from "jquery";
import moment from "moment";
import Spinner from "@/components/Spinner";
import Pin from "@/components/Pin";
import MediaPreview from "@/components/MediaPreview";
import Helper from "@/helper";

export default {
  name: "defects",
  components: {
    Pin,
    spinner: Spinner,
    MediaPreview,
  },
  data() {
    return {
      helper: Helper,
      currentImage: null,
      selectedCaseItem: null,
      isProcessing: false,
      map: null,
      cases: [],
      districts: [],
      currentDistrict: null,
      dateFilter: null,
      userDistricts: [],
      userRole: null,
      maintenanceLayers: [],
      showMaintenanceGroup: {},
      layers: [
        {
          id: "defects",
          layer: "circles",
          name: "Defects",
          show: true,
        },
      ],
    };
  },
  watch: {
    dateFilter() {
      $(".dropdown-toggle").dropdown("hide");

      this.getCases();
    },
    currentDistrict() {
      this.getCases();

      this.maintenanceLayers.forEach((route) => {
        if (
          !this.currentDistrict ||
          route.name.split(" - ")[0].toLowerCase() ==
            this.currentDistrict.name.toLowerCase()
        ) {
          route.show = true;
        } else {
          route.show = false;
        }

        this.toggleLayerVisibility(route);
      });
    },
  },
  methods: {
    toggleMaintenanceGroupVisibility(group) {
      this.maintenanceLayers
        .filter((l) => l.type == group)
        .forEach((route) => {
          route.show = this.showMaintenanceGroup[group];

          this.toggleLayerVisibility(route);
        });
    },
    toggleLayerVisibility(layer) {
      this.map.setLayoutProperty(
        layer.layer,
        "visibility",
        layer.show ? "visible" : "none"
      );
    },
    onPinSelected(caseItem) {
      this.selectedCaseItem = caseItem;
    },
    initMap() {
      return new Promise((resolve) => {
        mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_KEY;

        this.map = new mapboxgl.Map({
          container: "map",
          style: "mapbox://styles/mapbox/dark-v10",
          center: [103.71614734548582, 1.5225458699237464],
          zoom: 9,
        });

        this.map.on("load", async () => {
          const geocoder = new MapboxGeocoder({
            accessToken: process.env.VUE_APP_MAPBOX_KEY,
            mapboxgl: mapboxgl,
            marker: false,
          });

          geocoder.setCountries("MY");

          this.map.addControl(geocoder);

          resolve();
        });
      });
    },
    viewCase(caseId) {
      this.$router.push({ name: "inbox", params: { id: caseId } });
    },
    loadKML() {
      return new Promise(async (resolve) => {
        this.removeMaintenanceResources();

        this.maintenanceLayers = [];

        this.showMaintenanceGroup = {};

        const response = await API.get("layers");

        response.data
          .filter(
            (res) =>
              !this.currentDistrict ||
              res.name.split(" - ")[0].toLowerCase() ==
                this.currentDistrict.name.toLowerCase()
          )
          .forEach((layer) => {
            layer.show = true;
            layer.layer = `route-${layer.type}-${layer._id}`;

            this.maintenanceLayers.push(layer);

            this.$set(this.showMaintenanceGroup, layer.type, true);

            this.map.addSource(`route-${layer.type}-${layer._id}`, {
              type: "geojson",
              data: layer.file.url,
            });

            this.map.addLayer({
              id: `route-${layer.type}-${layer._id}`,
              type: "line",
              source: `route-${layer.type}-${layer._id}`,
              layout: {
                "line-join": "round",
                "line-cap": "round",
              },
              paint: {
                "line-color": ["get", "stroke"],
                "line-width": ["get", "stroke-width"],
                "line-opacity": ["get", "stroke-opacity"],
              },
            });
          });

        resolve();
      });
    },
    removeMaintenanceResources() {
      const layers = this.map
        .getStyle()
        .layers.filter((layer) => layer.id.includes("route-jalan_"));

      const sources = Object.keys(this.map.getStyle().sources).filter(
        (source) => source.includes("route-jalan_")
      );

      if (layers && layers.length > 0) {
        layers.forEach((layer) => {
          this.map.removeLayer(layer.id);
        });
      }

      if (sources && sources.length > 0) {
        sources.forEach((source) => {
          this.map.removeSource(source);
        });
      }
    },
    removeMapResources() {
      const layers = this.map
        .getStyle()
        .layers.filter((layer) => layer.id == "circles");

      const sources = Object.keys(this.map.getStyle().sources).filter(
        (source) => source == "circles"
      );

      if (layers && layers.length > 0) {
        layers.forEach((layer) => {
          this.map.removeLayer(layer.id);
        });
      }

      if (sources && sources.length > 0) {
        sources.forEach((source) => {
          this.map.removeSource(source);
        });
      }
    },
    async getCases() {
      this.isProcessing = true;

      this.removeMapResources();

      this.cases = [];

      let url =
        "cases/defects?timestamp_null=false&_sort=timestamp:DESC&_limit=-1&source_ne=socialMedia";

      if (this.currentDistrict) {
        url += `&district=${this.currentDistrict._id}`;
      } else if (
        this.userRole == "Supervisor" &&
        this.userDistricts.length > 0
      ) {
        url += `&district=${this.userDistricts
          .map((ud) => ud._id)
          .join("&district=")}`;
      }

      if (this.dateFilter && this.dateFilter.start && this.dateFilter.end) {
        const _dateFilter = {
          start: moment(this.dateFilter.start).startOf("day").toISOString(),
          end: moment(this.dateFilter.end).endOf("day").toISOString(),
        };

        url += `&timestamp_gte=${_dateFilter.start}&timestamp_lte=${_dateFilter.end}`;
      }

      return API.get(url)
        .then(async (retVal) => {
          this.cases = retVal.data.filter(
            (caseItem) => caseItem.lat != null && caseItem.lng != null
          );

          if (this.cases.length > 0) {
            let bounds = new mapboxgl.LngLatBounds();

            this.cases.forEach(function (c) {
              bounds.extend([c.lng, c.lat]);
            });

            this.map.fitBounds(bounds, {
              padding: 25,
              easing: (t) => {
                return t;
              },
            });
          }

          const features = this.cases
            .filter((c) => c.road)
            .map((c) => {
              return {
                type: "Feature",
                geometry: {
                  type: "Point",
                  coordinates: [c.lng, c.lat],
                },
                properties: {
                  id: c.id,
                  imageUrl: c.media && c.media.length ? c.media[0].url : "",
                  caption: c.caption,
                  roadName: c.road.name,
                },
              };
            });

          this.map.addSource("circles", {
            type: "geojson",
            data: {
              type: "FeatureCollection",
              features,
            },
          });

          this.map.addLayer({
            id: "circles",
            source: "circles",
            type: "circle",
            paint: {
              "circle-radius": 10,
              "circle-color": "red",
              "circle-opacity": 0.5,
              "circle-stroke-width": 0,
            },
          });

          this.map.on("mouseenter", "circles", () => {
            this.map.getCanvas().style.cursor = "pointer";
          });

          this.map.on("mouseleave", "circles", () => {
            this.map.getCanvas().style.cursor = "";
          });

          this.map.on("click", "circles", (e) => {
            const props = e.features[0].properties;

            const html = `
							<div class="mb-popup">
								<img class="defect-thumbnail clickable" src="${props.imageUrl}" />
								<div class="mb-cap">
                  <a class="text-dark" href="${API.apiUrl()}/admin/plugins/content-manager/collectionType/application::case.case/${
              props.id
            }" target="_blank">
                    ${props.caption}
                  </div>
                </a>
								<div class="mb-road">${props.roadName}</div>
							</div>
						`;

            new mapboxgl.Popup({
              maxWidth: "500px",
              closeButton: false,
              closeOnClick: true,
            })
              .setLngLat(e.lngLat)
              .setHTML(html)
              .on("open", () => {
                $(".defect-thumbnail").on("click", (e) => {
                  this.viewImage(e.target.src);
                });
              })
              .on("close", () => {
                $(".defect-thumbnail").off("click");
              })
              .addTo(this.map);
          });

          this.isProcessing = false;
        })
        .catch((err) => {
          console.error(err);

          this.isProcessing = false;
        });
    },
    viewImage(url) {
      this.currentImage = url;
    },
    async getDistricts() {
      this.isProcessing = true;

      let url = "districts?_sort=name";

      if (this.userRole == "Supervisor" && this.userDistricts.length > 0) {
        url = url
          .concat("&_id_in=")
          .concat(
            this.userDistricts.map((district) => district._id).join("&_id_in=")
          );
      }

      return API.get(url)
        .then((retVal) => {
          this.districts = retVal.data;

          this.isProcessing = false;
        })
        .catch((err) => {
          console.error(err);

          this.isProcessing = false;
        });
    },
  },
  async mounted() {
    this.isProcessing = true;

    let _user = localStorage.getItem("user");

    if (_user) {
      _user = JSON.parse(_user);

      if (_user.districts && _user.districts.length > 0) {
        this.userDistricts = _user.districts.map((district) => {
          return {
            _id: district._id,
            name: district.name,
          };
        });
      }

      this.userRole = _user.role.name;
    }

    await this.initMap();

    await this.getDistricts();

    await this.getCases();

    await this.loadKML();
  },
};
</script>
